import React from 'react';
import _ from 'lodash';
import Moment from 'moment';
import { DateSelectorPanel } from '../components/DateSelectorPanel';

import { WORK_HOUR_ZONES } from '../utilities/constants';

import '../styles/componentStyle/globalHeader/header-date-selector.scss';
import parts from '../utilities/parts';
import _urlParamManager from '../utilities/urlParamManager';
import EventManager, { EventType } from '../utilities/EventManager';

const DISABLED_DATE_SELECTOR_PAGES = [
  'WorkScheduleUnapproved',
  'WorkResultUnapproved',
];

export class HeaderDateSelector extends React.Component {
  constructor(props) {
    super(props);

    if (
      parts.inProperty(
        props,
        'positionKey,noShowDateFlag,field_id,' +
          'fromDate, toDate, workHourZone,' +
          'workHourZoneDayVisible, workHourZoneNightVisible, workHourZoneMidnightVisible,' +
          'handleChangeSearchDateRange'
      ) === false ||
      parts.propertyCount(props) !== 10
    ) {
      throw new Error('HeaderDateSelector.jsx constructor');
    }

    this.state = {
      hoverLabel: false,
      noShowDateFlag: this.props.noShowDateFlag,
      isDisabledDateAndWorkHourZone: false,
    };

    this.toggleDateSelector = this.toggleDateSelector.bind(this);
    this.handleClickWorkHourZone = this.handleClickWorkHourZone.bind(this);

    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentDidMount() {
    EventManager.addEventListener(
      EventType.ACCESS_UNAPPROVED_WORK_PAGE,
      this.switchDateAndWorkHourZoneStatus
    );
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ noShowDateFlag: nextProps.noShowDateFlag });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
    EventManager.removeEventListener(
      EventType.ACCESS_UNAPPROVED_WORK_PAGE,
      this.switchDateAndWorkHourZoneStatus
    );
  }

  handleClick = e => {
    if (this.node.contains(e.target)) {
      return;
    }

    this.handleClickOutside();
  };

  handleClickOutside = () => {
    this.setState({ hoverLabel: false });
  };

  toggleDateSelector = () => {
    const { hoverLabel } = this.state;
    this.setState({
      hoverLabel: !hoverLabel,
    });
  };

  handleClickWorkHourZone = key => {
    // console.log(key);
    this.props.handleChangeSearchDateRange({
      fromDate: this.props.fromDate,
      toDate: this.props.toDate,
      workHourZone: key,
    });
  };

  /**
   * 昼夜深夜の名称を返す
   * @param {*} workHourZoneKey 作業時間帯を示すKeyの指定 '1'|'2'|'3'
   */
  workHourBackGroundClass(workHourZoneKey) {
    switch (workHourZoneKey) {
      case WORK_HOUR_ZONES.day.key:
        return 'day';
      case WORK_HOUR_ZONES.night.key:
        return 'night';
      case WORK_HOUR_ZONES.midnight.key:
        return 'midnight';
      default:
        return 'day';
    }
  }

  /**
   * 日付情報を出力する
   * @param parameter.fromDate    期間開始
   * @param parameter.toDate      期間終了
   */
  dateRangeText({ fromDate, toDate }) {
    if (!parts.isStringAll(fromDate, toDate)) {
      throw new Error('HeaderDateSelector.jsx dateRangeText');
    }

    if (fromDate === toDate) {
      return `${Moment(fromDate, 'YYYY/MM/DD').format('YYYY/MM/DD(ddd)')}`;
    } else {
      return `${Moment(fromDate, 'YYYY/MM/DD').format(
        'YYYY/MM/DD(ddd)'
      )} 〜 ${Moment(toDate, 'YYYY/MM/DD').format('YYYY/MM/DD(ddd)')}`;
    }
  }

  /**
   * 表示中のページ「予定未承認/未受領一覧」「実績未承認/未確定一覧」画面の場合、日付と時間帯変更を非活性とする
   */
  switchDateAndWorkHourZoneStatus = () => {
    const currentPage = _.split(_urlParamManager.urlparam[0], ':')[0];
    this.setState({
      isDisabledDateAndWorkHourZone: _.includes(
        DISABLED_DATE_SELECTOR_PAGES,
        currentPage
      ),
    });
  };

  render() {
    const { workHourBackGroundClass, dateRangeText } = this;

    const { isDisabledDateAndWorkHourZone } = this.state;

    const {
      positionKey,
      fromDate,
      toDate,
      workHourZone,
      workHourZoneDayVisible,
      workHourZoneNightVisible,
      workHourZoneMidnightVisible,
      handleChangeSearchDateRange,
    } = this.props;

    const styles = {
      dateSelectorHeader: {
        display: 'flex',
      },
    };

    return (
      <div
        className={`date-dropdown-list date-selector date-time-${workHourBackGroundClass(
          workHourZone
        )}`}
        ref={node => (this.node = node)}
      >
        <div
          className='date-selector__header'
          style={styles.dateSelectorHeader}
        >
          <button
            className={'date-btn-header'}
            onClick={this.toggleDateSelector}
            disabled={isDisabledDateAndWorkHourZone}
          >
            <div className='date-btn-header__date'>
              <span className='date-btn-header__txt'>
                {dateRangeText({
                  fromDate,
                  toDate,
                })}
              </span>
            </div>
            <i className='i-arrow-bottom--light i-3x' aria-hidden='true' />
          </button>
          <ul className='work-hour-zone'>
            {workHourZoneDayVisible && (
              <li className='work-hour-zone__list-item'>
                <button
                  className={
                    workHourZone !== WORK_HOUR_ZONES.day.key
                      ? 'work-hour-zone__button work-hour-zone__button--day'
                      : 'work-hour-zone__button work-hour-zone__button--day work-hour-zone__button--active'
                  }
                  onClick={() => {
                    this.handleClickWorkHourZone(WORK_HOUR_ZONES.day.key);
                  }}
                  disabled={isDisabledDateAndWorkHourZone}
                >
                  <i className='work-hour-zone__icon work-hour-zone__icon--day' />
                  <p className='work-hour-zone__button-text'>昼</p>
                </button>
              </li>
            )}
            {workHourZoneNightVisible && (
              <li className='work-hour-zone__list-item'>
                <button
                  className={
                    workHourZone !== WORK_HOUR_ZONES.night.key
                      ? 'work-hour-zone__button work-hour-zone__button--night'
                      : 'work-hour-zone__button work-hour-zone__button--night work-hour-zone__button--active'
                  }
                  onClick={() => {
                    this.handleClickWorkHourZone(WORK_HOUR_ZONES.night.key);
                  }}
                  disabled={isDisabledDateAndWorkHourZone}
                >
                  <i className='work-hour-zone__icon work-hour-zone__icon--night' />
                  <p className='work-hour-zone__button-text'>夜</p>
                </button>
              </li>
            )}
            {workHourZoneMidnightVisible && (
              <li className='work-hour-zone__list-item'>
                <button
                  className={
                    workHourZone !== WORK_HOUR_ZONES.midnight.key
                      ? 'work-hour-zone__button work-hour-zone__button--midnight'
                      : 'work-hour-zone__button work-hour-zone__button--midnight work-hour-zone__button--active'
                  }
                  onClick={() => {
                    this.handleClickWorkHourZone(WORK_HOUR_ZONES.midnight.key);
                  }}
                  disabled={isDisabledDateAndWorkHourZone}
                >
                  <i className='work-hour-zone__icon work-hour-zone__icon--midnight' />
                  <p className='work-hour-zone__button-text'>深夜</p>
                </button>
              </li>
            )}
          </ul>
        </div>
        <DateSelectorPanel
          show={this.state.hoverLabel}
          {...{
            positionKey,
            fromDate,
            toDate,
            workHourZone,
            workHourZoneDayVisible,
            workHourZoneNightVisible,
            workHourZoneMidnightVisible,
          }}
          onChangeSearchDateRange={handleChangeSearchDateRange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HeaderDateSelector.jsx